import React, { useState, useEffect, useRef } from 'react';
import { API_URL } from '../styles/shared';
import ShareCard from '../components/ShareCard';

export default function SharePage({ shareId, navigateTo }) {
  const [card, setCard]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const cardRef               = useRef(null);

  // T1 — OG meta tags for social sharing
  useEffect(() => {
    if (!card) return;
    const emoji = card.signal === 'BULLISH' ? '🟢' : card.signal === 'BEARISH' ? '🔴' : '🟡';
    const title = `${emoji} ${card.ticker} — ${card.signal} ${card.score}/100 | MarketPulze`;
    const desc  = `${card.companyName} (${card.ticker}) scores ${card.score}/100. Algorithmic signal: ${card.signal}. Not investment advice.`;
    document.title = title;
    const setMeta = (prop, val, attr = 'property') => {
      let el = document.querySelector(`meta[${attr}="${prop}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, prop); document.head.appendChild(el); }
      el.setAttribute('content', val);
    };
    setMeta('og:title', title); setMeta('og:description', desc);
    setMeta('og:url', window.location.href); setMeta('og:type', 'website');
    setMeta('og:site_name', 'MarketPulze');
    setMeta('description', desc, 'name');
    setMeta('twitter:card', 'summary', 'name');
    setMeta('twitter:title', title, 'name');
    setMeta('twitter:description', desc, 'name');
    return () => { document.title = 'MarketPulze'; };
  }, [card]);

  useEffect(() => {
    if (!shareId) { setError('Invalid share link.'); setLoading(false); return; }
    fetch(`${API_URL}/api/share/${shareId}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) setCard(data.card);
        else setError('This analysis card has expired or does not exist.');
      })
      .catch(() => setError('Unable to load this card. Please try again.'))
      .finally(() => setLoading(false));
  }, [shareId]);

  const pageStyle = {
    minHeight: '100vh',
    background: '#0f1923',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
  };

  if (loading) return (
    <div style={pageStyle}>
      <div style={{ color: '#64748b', fontSize: 15 }}>Loading analysis card…</div>
    </div>
  );

  if (error) return (
    <div style={pageStyle}>
      <div style={{ color: '#ef4444', fontSize: 15, marginBottom: 24 }}>{error}</div>
      <button onClick={() => navigateTo('home')} style={{
        background: '#00ff88', color: '#0f1923', border: 'none',
        borderRadius: 8, padding: '10px 20px', fontWeight: 700, cursor: 'pointer'
      }}>← Back to MarketPulze</button>
    </div>
  );

  return (
    <div style={pageStyle}>
      {/* SEO-friendly heading (crawlable) */}
      <h1 style={{
        fontSize: 15, color: '#475569', marginBottom: 28,
        textAlign: 'center', fontWeight: 400
      }}>
        MarketPulze · Algorithmic Signal for {card.ticker}
      </h1>

      <ShareCard card={card} showButtons cardRef={cardRef} />

      {/* Growth CTA */}
      <div style={{
        marginTop: 36, maxWidth: 420, width: '100%',
        background: '#1a2535', border: '1px solid #2d4060',
        borderRadius: 16, padding: '24px 28px', textAlign: 'center'
      }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: '#f1f5f9', marginBottom: 8 }}>
          Want algorithmic analysis on any stock?
        </div>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 20, lineHeight: 1.6 }}>
          MarketPulze is invite-only. Request access to run your own
          algorithmic analysis — BULLISH, NEUTRAL, or BEARISH signals
          with full transparency. Not investment advice.
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <button onClick={() => navigateTo('home')} style={{
          background: 'linear-gradient(135deg, #00ff88, #00d4ff)',
          color: '#0f1923', border: 'none', borderRadius: 8,
          padding: '12px 28px', fontSize: 14, fontWeight: 700,
          cursor: 'pointer', letterSpacing: '0.02em'
        }}>
          Request Invite →
        </button>
        </div>
      </div>

      <div style={{ marginTop: 20, fontSize: 11, color: '#334155', textAlign: 'center' }}>
        Algorithmic signal · Not investment advice · Data delayed 15 min ·{' '}
        <span
          onClick={() => navigateTo('home')}
          style={{ color: '#475569', cursor: 'pointer', textDecoration: 'underline' }}
        >marketpulze.com</span>
      </div>
    </div>
  );
}
